import { render, staticRenderFns } from "./LgFinderPageEmpenho.vue?vue&type=template&id=33f563ee"
import script from "./LgFinderPageEmpenho.vue?vue&type=script&lang=js"
export * from "./LgFinderPageEmpenho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports